import { render, staticRenderFns } from "./offboard.vue?vue&type=template&id=7bafb263&scoped=true"
import script from "./offboard.vue?vue&type=script&lang=js"
export * from "./offboard.vue?vue&type=script&lang=js"
import style0 from "./offboard.vue?vue&type=style&index=0&id=7bafb263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bafb263",
  null
  
)

export default component.exports